/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
$(document).ready(function(){
document.querySelector(".openBtn").addEventListener("click", () => {
  openSearch("#myOverlay");
});
document.querySelector(".closebtn").addEventListener("click", () => {
  closeSearch("#myOverlay");
});

document.querySelector(".openBtn-mobile").addEventListener("click", () => {
  openSearch("#myOverlay2");
});
document.querySelector(".closebtn-mobile").addEventListener("click", () => {
  closeSearch("#myOverlay2");
});

function openSearch(args) {
  document.querySelector(`${args}`).style.display = "block";
}
function closeSearch(args2) {
  document.querySelector(`${args2}`).style.display = "none";
}
});
// Insert any custom theme js here...
